import { makeStyles } from 'tss-react/mui';

interface Props {
  isOnDark: boolean;
}

const useStyles = makeStyles<Props>({
  name: 'FeatureLink',
})(({ brandColors, type, breakpoints, typography }, { isOnDark }) => ({
  card: {
    justifyContent: 'space-between',
    borderRadius: typography.pxToRem(24),
    display: 'flex',
    flexDirection: 'column',
    ...type['20_regular'],
    width: 'auto',
    height: '100%',
    background: `${
      isOnDark
        ? 'linear-gradient(180deg, #000 5.73%, rgba(0, 0, 0, 0.00) 72.92%), rgba(0, 0, 0, 0.80)'
        : brandColors.tintsHeroBlue80
    }`,
    '&:hover': {
      '& a': {
        color: `${isOnDark ? 'white' : brandColors.mediumBlue}`,
        border: `${
          isOnDark
            ? `${typography.pxToRem(1)} solid white`
            : `${typography.pxToRem(1)} solid ${brandColors.mediumBlue}`
        }`,
        backgroundColor: `${
          isOnDark
            ? brandColors.foregroundInverseSubtle
            : brandColors.interactiveHeroBlueSubtle
        }`,
      },
    },
    [breakpoints.up('md')]: { ...type['28_medium'] },
    [breakpoints.up('lg')]: {
      width: '100%',
      height: typography.pxToRem(370),
    },
  },
  cardBackgroundImg: {
    width: '100%',
    height: '100%',
    borderRadius: typography.pxToRem(24),
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    [breakpoints.up('lg')]: {
      backgroundSize: '100%',
      transition: 'background-size .5s',
      '&:hover': {
        backgroundSize: '110%',
      },
    },
  },
  linkContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    height: '100%',
    padding: typography.pxToRem(32),
  },
  title: {
    color: `${isOnDark ? brandColors.white : brandColors.mediumBlue}`,
    width: '80%',
    [breakpoints.up('sm')]: {
      width: '40%',
    },
    [breakpoints.up('md')]: {
      width: '50%',
    },
  },
}));

export default useStyles;
